/**
 * Утилиты для работы с датами на клиенте
 * ======================================
 * 
 * ВАЖНО: Работа с серверным временем
 * - Пользователь выбирает СЕРВЕРНОЕ время в интерфейсе
 * - Даты передаются на сервер в формате YYYY-MM-DD (без timezone)
 * - Сервер интерпретирует даты как локальное (серверное) время
 * 
 * Это означает что если пользователь выбрал "25 ноября" в календаре,
 * на сервер отправится "2025-11-25" и сервер будет искать данные
 * за 25 ноября по своему локальному времени.
 */

// Простые функции для нормализации дат
// ВСЕГДА устанавливаем начало и конец дня

export const normalizeStartDate = (date, time = null) => {
  if (!date) return null;
  const normalized = new Date(date);
  
  if (time) {
    // Если передано время, используем его
    normalized.setHours(time.hours ?? 0, time.minutes ?? 0, 0, 0);
  } else {
    // По умолчанию начало дня
    normalized.setHours(0, 0, 0, 0);
  }
  
  return normalized;
};

export const normalizeEndDate = (date, time = null) => {
  if (!date) return null;
  const normalized = new Date(date);
  
  if (time) {
    // Если передано время, используем его
    normalized.setHours(time.hours ?? 23, time.minutes ?? 59, 59, 999);
  } else {
    // По умолчанию конец дня
    normalized.setHours(23, 59, 59, 999);
  }
  
  return normalized;
};

// Функции для работы с временем
export const parseTimeString = (timeStr) => {
  if (!timeStr) return null;
  const [hours, minutes] = timeStr.split(':').map(Number);
  return { hours: hours || 0, minutes: minutes || 0 };
};

export const formatTimeString = (hours, minutes) => {
  const h = String(hours || 0).padStart(2, '0');
  const m = String(minutes || 0).padStart(2, '0');
  return `${h}:${m}`;
};

export const getTimeFromDate = (date) => {
  if (!date) return null;
  return {
    hours: date.getHours(),
    minutes: date.getMinutes()
  };
};
